
export const SearchViewMock = {
    id: "1",
    name: "",
    recentSearches: [
        {id: "1", name: "Song", genre: "Rock",},
        {id: "2", name: "Song", genre: "Rock",},
        {id: "3", name: "Song", genre: "Rock",},
        {id: "4", name: "Song", genre: "Rock",},
        {id: "5", name: "Song", genre: "Rock",},
        {id: "6", name: "Song", genre: "Rock",},
        {id: "7", name: "Song", genre: "Rock",},
        {id: "8", name: "Song", genre: "Rock",},
    ],
    genres: [
        {id: "1", name: "Podcasts",},
        {id: "2", name: "Made For You",},
        {id: "3", name: "Charts",},
        {id: "4", name: "New Releases",},
        {id: "5", name: "Discover",},
        {id: "6", name: "Concerts",},
        {id: "8", name: "Pop",},
        {id: "9", name: "Hip-Hop",},
        {id: "10", name: "Mood",},
        {id: "11", name: "Indie",},
        {id: "12", name: "Ramadan",},
        {id: "13", name: "EQUAL",},
        {id: "14", name: "Dance",},
        {id: "15", name: "Chill",},
        {id: "16", name: "Workout",},
        {id: "17", name: "Rock",},
        {id: "18", name: "At Home",},
        {id: "19", name: "Metal",},
        {id: "20", name: "Decades",},
        {id: "234", name: "R&B",},
        {id: "21", name: "Dansband",},
        {id: "22", name: "Wellness",},
        {id: "23", name: "Focus",},
        {id: "24", name: "Cooking",},
        {id: "25", name: "Party",},
        {id: "26", name: "Country",},
        {id: "27", name: "Soul",},
        {id: "28", name: "Sleep",},
        {id: "29", name: "Afro",},
        {id: "30", name: "Jazz",},
        {id: "31", name: "Romance",},
        {id: "32", name: "Caribbean",},
        {id: "33", name: "K-Pop",},
        {id: "34", name: "Testemakers",},
        {id: "35", name: "Folk",},
        {id: "36", name: "Instrumental",},
        {id: "37", name: "Netflix",},
        {id: "38", name: "Ambient",},
        {id: "39", name: "API",},
        {id: "41", name: "Pride",},
        {id: "42", name: "Songwriters",},
        {id: "43", name: "Classical",},
        {id: "44", name: "Blues",},
        {id: "45", name: "Punk",},
        {id: "46", name: "Funk",},
        {id: "47", name: "Travel",},
        {id: "48", name: "Gaming",},
        {id: "49", name: "League",},
        {id: "50", name: "Trending",},
        {id: "51", name: "Music & Talk",},
        {id: "52", name: "Summer",},
    ]
}